import ClientLoggerFactory from "../../lib/logging/ClientLoggerFactory";
import LoggerCommonTags from "../../lib/logging/LoggerCommonTags";
import { get } from "lodash";
import { levenshteinEditDistance } from 'levenshtein-edit-distance';

const logger = ClientLoggerFactory.getClientLogger("useDeleteImages");
const COMPARISON_LIKENESS_THRESHOLD = 2;

type Matcher = {
    readonly targetKey: string;
    readonly value: string;
}

type CheckForDuplicatesProps<T> = {
    readonly matchers: Array<Matcher>;
    readonly fetchAllItems: () => (Promise<Array<T>>);
    readonly itemType: string;
}

export const checkForDuplicates = async <T,>(props: CheckForDuplicatesProps<T>) => {
    const { matchers: valuesToMatch, fetchAllItems, itemType } = props;

    try {
        const response: Array<T> = await fetchAllItems();

        const filteredResults = response.filter((item: T) => {
            let isMatch = false;
            for (let i = 0; i < valuesToMatch.length; i++) {
                const itemValue = get(item, valuesToMatch[i].targetKey, '');
                if (!itemValue) {
                    continue;
                }
                if (levenshteinEditDistance(itemValue as string, valuesToMatch[i].value) <= COMPARISON_LIKENESS_THRESHOLD) {
                    isMatch = true;
                }
            };
            return isMatch;
        })
        return (filteredResults);
    } catch (error) {
        logger.error(
            `Failed to retrieve possibly duplicate items of type ${itemType}`,
            error,
            [LoggerCommonTags.PROPERTY_LIST_RETRIEVAL_FAILURE]
        );
    }
}
